exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CheckboxList__container{font:var(--main-font);white-space:nowrap}.CheckboxList__label{font-size:11px;font-weight:700;margin-bottom:7px}.CheckboxList__item+.CheckboxList__item{margin-top:1px}", ""]);

// exports
exports.locals = {
	"container": "CheckboxList__container",
	"label": "CheckboxList__label",
	"item": "CheckboxList__item"
};